import Cache from '@fs/zion-cache'
import axios from '@fs/zion-axios'

const userSegmentCache = new Cache({ dbName: 'segment', storeName: 'users', type: 'local', lifetime: 'day' })

export const getUserSegment = async (cisId) => {
  if (cisId) {
    const key = `${cisId}-pb-user-segment`
    let stats = await userSegmentCache.getItemData(key)
    if (!stats) {
      stats = await axios.get(`/service/home/pb/users/${cisId}/segment`).then(({ data }) => data)
      userSegmentCache.setItemData(key, stats)
    }
    return stats
  }
  return null
}

export default null
